var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-design robot3" }, [
    _c("div", { staticClass: "banner", attrs: { id: "design-b1" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1" }, [
          _c("b", { class: { fadeUp: _vm.isB1Visible } }, [_vm._v("独具创新")]),
          _c("span", { class: { fadeDown: _vm.isB1Visible } }, [
            _vm._v("多模态设计")
          ])
        ]),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeDown: _vm.isB1Visible } },
          [_vm._v("伸缩、旋转形态自由切换，可静可动，造型由你定义")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b2" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB2Visible } }, [
          _vm._v("精于心，减于形")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("区别于传统机器人造型，融于家的简洁几何线条设计")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b3" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB3Visible } }, [
          _vm._v("不妥协，追求质感")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("高端布料和金属质感，让家别具一份精致")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b4" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB4Visible } }, [
          _vm._v("不止于形")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("深入考究人机交互")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay1", class: { fadeUp: _vm.isB4Visible } },
          [
            _vm._v("不止于外形，充分考虑躺，坐，站情况下的交互"),
            _c("br"),
            _vm._v("结合表情声音动作让人与机器人的交互更自然")
          ]
        ),
        _c(
          "div",
          { staticClass: "face-list" },
          _vm._l(_vm.face, function(value, key) {
            return _c(
              "div",
              {
                staticClass: "item",
                class: { active: key === _vm.currentFace },
                on: {
                  click: function($event) {
                    _vm.selectFace(key)
                  },
                  mouseover: function($event) {
                    _vm.selectFace(key)
                  }
                }
              },
              [
                _c("div", { staticClass: "icon", class: [key] }),
                _c("p", [_vm._v(_vm._s(value))])
              ]
            )
          })
        ),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentFace === "laugh",
              expression: "currentFace === 'laugh'"
            }
          ],
          staticClass: "face-gif",
          attrs: { src: require("../../../assets/web/face-laugh.gif") }
        }),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentFace === "angry",
              expression: "currentFace === 'angry'"
            }
          ],
          staticClass: "face-gif",
          attrs: { src: require("../../../assets/web/face-angry.gif") }
        }),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentFace === "cry",
              expression: "currentFace === 'cry'"
            }
          ],
          staticClass: "face-gif",
          attrs: { src: require("../../../assets/web/face-cry.gif") }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64a35226", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a35226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/3/design.vue
// module id = d3Mp
// module chunks = 0